<template>
    <div class="not-logged-in">
        <template v-if="!showAuthLink">
            <router-link
                v-if="$route.name != 'bi-landing' && isBiSubscribed"
                :to="{ name: 'bi-sign-up'}"
                tag="button"
                class="btn btn-outline-primary"
            >
                Sign Up
            </router-link>
            <button
                v-if="!isBiSubscribed && $route.name != 'bi-landing'"
                tag="button"
                class="btn btn-primary"
                @click="onSignUpForFreeClicked"
            >
                Sign Up for Free
            </button>
            <button
                v-if="$route.name == 'bi-landing' && showSubscribeBtn"
                class="btn btn-primary"
                @click="$modal.show('authentication-forms-modal', { formType: 'sign-up'})"
            >
                Sign Up for Free
            </button>
            <router-link
                v-if="$route.name == 'bi-landing' && !showSubscribeBtn"
                :to="{ name: 'bi-sign-in', query: { redirect: $route.path }}"
                @click.native="trackGTMEvent"
            >
                Sign In
            </router-link>
            <router-link v-if="$route.name != 'bi-landing'" :to="{ name: 'bi-sign-in', query: { redirect: $route.path }}" @click.native="trackGTMEvent">
                Sign In
            </router-link>
        </template>
        <template v-if="showAuthLink">
            <router-link :to="{ ...customAuthRoute }" tag="button" class="btn btn-outline-primary">
                {{ customTitle }}
            </router-link>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "NotLoggedIn",
    computed: {
        isBiSubscribed() {
            const isBiSubscribed = localStorage.getItem("bi-subscribed");
            return Boolean(isBiSubscribed);
        },
        showAuthLink() {
            const authRoutes = [
                "bi-sign-in",
                "bi-sign-up"
            ];

            return authRoutes.includes(this.$route.name);
        },
        customAuthRoute() {
            const alternativeRoutes = {
                "bi-sign-in": "bi-sign-up",
                "bi-sign-up": "bi-sign-in"
            };

            const route = {
                name: alternativeRoutes[this.$route.name],
                params: { ...this.$route.params },
                query: { ...this.$route.query }
            };

            if (this.$route.name == "bi-sign-in") {
                delete route.query.redirect;
            }

            return route;
        },
        customTitle() {
            return this.$route.name.includes("sign-up") ? "Sign In" : "Sign Up";
        },
        ...mapState({
            showSubscribeBtn: state => state.Application.showSubscribeBtn
        })
    },
    methods: {
        trackGTMEvent() {
            const gtmEvent = {
                event: "bi-nav-allpages-signin",
                action: "signin"
            };

            this.$_gtmTrackEvent(gtmEvent);
        },
        onSignUpForFreeClicked() {
            if (this.$route.name !== "bi-discover") {
                this.$router.push({ name: "bi-landing" });
                return;
            }
            this.$modal.show("authentication-forms-modal", { formType: "sign-up" })
        }
    }
}
</script>

<style lang="scss">
.not-logged-in {
    display: flex;
    align-items: center;

    button {
        padding: .6rem 0.9rem;
        border-radius: 30px;

        @media (max-width: $md) {
            padding: .6rem 0.3rem;
        }
    }

    a {
        padding: .6rem 20px;
        padding-right: 0;
        text-decoration: none;
        font-size: 15px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        color: white;

        @media (max-width: $md) {
            padding-left: 10px;
        }
    }
}
</style>
